"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uint8FromBufferLike = exports.uint8FromHex = exports.uint8ToHex = exports.calculateFactor = void 0;
/**
 * Calculate factoriel of n.
 */
const calculateFactor = (x, y = 256) => Math.log(x) / Math.log(y);
exports.calculateFactor = calculateFactor;
/**
 * Convert a Uint8Array to a hex string.
 *
 * Same as below:
 *  const buffer = Buffer.from('0x010203040506', 'hex');
 */
const uint8ToHex = (uint8) => Array.from(uint8).reduce((acc, curr) => acc + curr.toString(16).padStart(2, '0'), '');
exports.uint8ToHex = uint8ToHex;
/**
 * Convert a hex string to a Uint8Array.
 *
 * Same as below:
 *  const hexString = Buffer.from(uint8array).toString('hex');
 */
const uint8FromHex = (hex) => {
    var _a;
    // return zero length array if empty string
    if (!hex.length)
        return new Uint8Array(0);
    return new Uint8Array(((_a = hex.match(/.{1,2}/g)) !== null && _a !== void 0 ? _a : []).map((byte) => parseInt(byte, 16)));
};
exports.uint8FromHex = uint8FromHex;
/**
 * Convert a BufferLike object to a Uint8Array.
 */
const uint8FromBufferLike = (buffer) => buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
exports.uint8FromBufferLike = uint8FromBufferLike;
